export default {
    type: 'image',
    config: {
        unsortable: true,
        fixedWidth: 48
    },
    default: {},
    unique: [
        {
            key: 'size',
            type: 'checklist',
            default: 'square',
            name: 'Cropping',
            options: [
                {
                    value: 'natural',
                    text: 'Natural',
                    description: 'The box art proportions are preserved.'
                },
                {
                    value: 'square',
                    text: 'Square',
                    description: 'The box art is zoom cropped to fill a square.'
                }
            ]
        },
        {
            key: 'radius',
            type: 'percent',
            default: 0,
            placeholder: 'No radius',
            name: 'Corner Radius',
            visibility: function(settings) {

                return settings.size === 'square'

            },
            preview: function(value) {

                return value.toString() + '%'

            }
        },
        {
            key: 'rating',
            type: 'checklist',
            default: 'disabled',
            placeholder: 'Disabled',
            name: 'Rating',
            contexts: ['ratings'],
            views: ['gallery'],
            options: [
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide rating',
                    description: 'Show the user rating on the image'
                },
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show rating',
                    description: 'Don\'t show the user rating on the image'
                }
            ]
        },
        {
            key: 'plays',
            type: 'checklist',
            default: 'enabled',
            placeholder: 'Enabled',
            name: 'Plays',
            contexts: ['gameplays'],
            views: ['gallery'],
            options: [
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide plays',
                    description: 'Show total plays on the image'
                },
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show plays',
                    description: 'Don\'t show total plays on the image'
                }
            ]
        },
        {
            key: 'date',
            type: 'checklist',
            default: 'enabled',
            placeholder: 'Enabled',
            name: 'Date',
            contexts: ['gameplays'],
            views: ['gallery'],
            options: [
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide date',
                    description: 'Show play date on the image'
                },
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show date',
                    description: 'Don\'t show play date on the image'
                }
            ]
        }
    ],
    lang: {
        name: 'Box Art',
        views: ['list'],
        category: 'Game',
        description: 'Show an image of the game box art.'
    }
}